<template>
  <div class="toast" :class="type">
    <span class="icon" v-html="icon"></span>
    <p>{{ message }}</p>
  </div>
</template>

<script setup>
import { computed } from "vue";

const props = defineProps({
  message: String,
  type: {
    type: String,
    default: "info",
  },
});

const icon = computed(() => {
  switch (props.type) {
    case "success":
      return "✅";
    case "error":
      return "❌";
    case "warning":
      return "⚠️";
    default:
      return "ℹ️";
  }
});
</script>

<style scoped>
.toast {
  position: fixed;
  bottom: 24px;
  right: 24px;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 14px 20px;
  border-radius: 10px;
  font-weight: 600;
  color: #3a2c1a;
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.1);
  z-index: 9999;
  animation: fadeSlide 0.35s ease;
  max-width: 340px;
  line-height: 1.4;
  word-break: break-word;
  backdrop-filter: blur(6px);
  border: 1px solid rgba(0, 0, 0, 0.05);
  transition:
    transform 0.3s ease,
    opacity 0.3s ease;
}

.icon {
  font-size: 1.2rem;
  flex-shrink: 0;
}

/* === CORES LEVES === */
.toast.info {
  background: linear-gradient(90deg, #fffaf4, #fefcf7);
  border-left: 4px solid #ffd580;
  color: #4a3b1e;
}

.toast.success {
  background: linear-gradient(90deg, #fef8e8, #fffdf8);
  border-left: 4px solid #f7b955;
  color: #3d2b14;
}

.toast.warning {
  background: linear-gradient(90deg, #fff4e3, #fff9f0);
  border-left: 4px solid #ffcc80;
  color: #5a3a00;
}

.toast.error {
  background: linear-gradient(90deg, #fff1f1, #fff8f8);
  border-left: 4px solid #ff9ea0;
  color: #7a1c1c;
}

/* === ANIMAÇÃO === */
@keyframes fadeSlide {
  from {
    transform: translateY(20px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

/* === INTERAÇÃO SUAVE === */
.toast:hover {
  transform: translateY(-3px);
  box-shadow: 0 10px 22px rgba(0, 0, 0, 0.15);
}
</style>
